var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome4Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/buildings/home_4_fill",
    clipPath: "url(#clip0_14046_4422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8 1.76667C8.32593 1.41111 7.67407 1.41111 7.2 1.76667L2.53333 5.26667C2.19759 5.51847 2 5.91366 2 6.33333V12.6667C2 13.4031 2.59695 14 3.33333 14H5.93333C6.33834 14 6.66667 13.6717 6.66667 13.2667V10C6.66667 9.2636 7.2636 8.66667 8 8.66667C8.7364 8.66667 9.33333 9.2636 9.33333 10V13.2667C9.33333 13.6717 9.66167 14 10.0667 14H12.6667C13.4031 14 14 13.4031 14 12.6667V6.33333C14 5.91366 13.8024 5.51847 13.4667 5.26667L8.8 1.76667Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14046_4422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome4Fill);
export default __webpack_public_path__ + "static/media/home_4_fill.d1c29c7f079584e3f439d6c5810bd28f.svg";
export { ForwardRef as ReactComponent };